import { ShortcutsDirective } from './shortcuts.directive';
import { ContentModelDirective } from './content-model.directive';

export {
  ShortcutsDirective,
  ContentModelDirective
};

export const SHARED_DIRECTIVES = [
  ShortcutsDirective,
  ContentModelDirective
];
